import React from 'react';
const studio_conversations = 'Studio <br /> Conversations';

const HeaderDropNav = ({ onClick, currentPage, linkClass }) => (
  <div className={'nav-header'} onClick={onClick}>
    <div className={linkClass}>{

      (currentPage == 'Studio-conversations' || currentPage == 'Studio-conversation') ? <span dangerouslySetInnerHTML={{ __html:studio_conversations}}></span> : currentPage
      
      }</div>
    <div className={'nav-divot'}/>
  </div>
);

export default HeaderDropNav;



// WEBPACK FOOTER //
// ./src/components/HeaderDropNav.js